export default __webpack_public_path__ + "static/media/private_capital_filled.5bb38fba.png";